import { clsx } from 'clsx'

import { FC } from 'react'

import { AnimationShowBlockComponent } from '@/app/shared/components/animation/show-block'
import { getColorIcon } from '@/app/shared/components/list/services'
import { IconCheck } from '@/app/shared/icons'
import { IClassName } from '@/app/shared/interfaces/common.interface'

// interface
interface IList extends IClassName {
  data: string[]
  colorIcon?: string
  classIcon?: string
  noAnimation?: boolean
  editor?: boolean
}

// component
const ListComponent: FC<Readonly<IList>> = ({
  data,
  className,
  colorIcon,
  classIcon,
  noAnimation,
  editor,
}) => {
  const colorIconFormat = getColorIcon(colorIcon)

  return (
    <ul className={clsx('grid gap-2.5 break-words', className)}>
      {data.map((el, index) => (
        <AnimationShowBlockComponent
          key={`${index}_${el}`}
          initial={
            !noAnimation
              ? {
                  opacity: 0,
                  x: 50,
                }
              : undefined
          }
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            delay: 0.4 * (index + 1),
          }}
        >
          <li className={'flex items-center break-words'} style={{ wordBreak: 'break-word' }}>
            <IconCheck
              className={clsx('mr-2.5 h-6 w-6 flex-shrink-0', colorIconFormat, classIcon)}
            />
            {editor ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: el,
                }}
              />
            ) : (
              el
            )}
          </li>
        </AnimationShowBlockComponent>
      ))}
    </ul>
  )
}

export default ListComponent
